<template>
  <div id="basic-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BasicCard"
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#basic-card {
  height: fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  box-shadow: $basic-shadow;
  border: 2px solid $color-primary;
}
</style>
